// import './App.css';
import { useEffect, useState } from "react";
import Modal from "react-modal";
import LoadingOverlay from "react-loading-overlay";
import { useHistory } from "react-router-dom";
import { getOrganizations } from "../services/api";
import OrganizationsTable from "../components/organizationsTable";

function Organizations() {
  let history = useHistory();

  const [organizations, setOrganizations] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getOrganizations()
      .then((res) => {
        setOrganizations(res);
        console.log(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onEdit = (organization) => {
    history.push(`/organization/${organization}`);
  };

  // const onEditDataAssessment = (assessment) => {
  //   setEditOrganization(assessment);
  // };

  // const onDeleteOrganization = (assessment) => {};

  // const onSaveSuccess = (assessment) => {};

  // const closeModal = () => {
  //   setEditOrganization(null);
  // };

  return (
    <LoadingOverlay active={loading} spinner>
      {organizations && <OrganizationsTable organizations={organizations} onEdit={onEdit} />}
      {/* <Modal
        isOpen={editOrganization}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        className="modalEdit"
        style={{ overlay: { zIndex: 1000 } }}
      >
        {editOrganization && (
          <AssessmentForm assessment={editOrganization} organizationId={organizationId} onSaveSuccess={onSaveSuccess} />
        )}
      </Modal> */}
    </LoadingOverlay>
  );
}

export default Organizations;
